import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../stores'
import { IoHeartOutline } from 'react-icons/io5'
import toast from 'react-hot-toast'
import { pscAuthService } from '../services/api/psc'

export default function PscCallback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { login } = useAuthStore()
  const processed = useRef(false)

  useEffect(() => {
    if (processed.current) return
    processed.current = true

    const error = searchParams.get('error')
    const exchangeCode = searchParams.get('code')

    if (error) {
      toast.error(`Connexion PSC refusée : ${error}`)
      navigate('/login', { replace: true })
      return
    }

    if (!exchangeCode) {
      toast.error('Réponse PSC invalide')
      navigate('/login', { replace: true })
      return
    }

    // Effacer le code de l'URL immédiatement (ne doit pas rester dans l'historique)
    window.history.replaceState({}, '', window.location.pathname)

    void pscAuthService.exchangeCode(exchangeCode).then(response => {
      const authData = response.data
      if (!authData?.user || !authData.accessToken || !authData.refreshToken) {
        toast.error('Réponse serveur invalide')
        navigate('/login', { replace: true })
        return
      }
      login(authData.user, authData.accessToken, authData.refreshToken)
      toast.success('Connexion Pro Santé Connect réussie')
      navigate('/app', { replace: true })
    }).catch(() => {
      toast.error('Erreur lors de la connexion PSC — veuillez réessayer')
      navigate('/login', { replace: true })
    })
  }, [searchParams, login, navigate])

  return (
    <div className='min-h-screen bg-gray-50 dark:bg-dark-50 flex items-center justify-center'>
      <div className='text-center space-y-4'>
        <div className='w-14 h-14 rounded-2xl bg-primary-600 flex items-center justify-center mx-auto animate-pulse'>
          <IoHeartOutline className='text-white text-2xl' />
        </div>
        <h2 className='text-xl font-semibold text-gray-900 dark:text-white'>
          Connexion Pro Santé Connect
        </h2>
        <p className='text-gray-500 dark:text-gray-400 text-sm'>
          Vérification de votre identité en cours...
        </p>
        <div className='flex items-center justify-center gap-1.5'>
          {[0, 1, 2].map(i => (
            <div
              key={i}
              className='w-2 h-2 rounded-full bg-primary-600 animate-bounce'
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
